import { useContext } from 'react';

import { Runtime } from './RuntimeProvider.context';
import type { RuntimeType } from './RuntimeProvider.context';

export const useRuntime = (): RuntimeType => {
  const contextValue = useContext(Runtime);

  if (contextValue === undefined) {
    throw new Error('useRuntime must be used within a RenderingContextProvider');
  }

  return contextValue;
};
